/**
* this file contains the array for the left menu component
*
* Created by Paul on 28/5/19
*/

import config from '../../config'

// menu icon import
import DashIcon from '../../assets/svg/dash.svg'
import MyFundIcon from '../../assets/svg/wallet.svg'
import TradingIcon from '../../assets/svg/trading.svg'
import DocumentIcon from '../../assets/svg/documents.svg'
import BillingIcon from '../../assets/svg/billing.svg'

const menuItems = [
    {
        menuIcon: MyFundIcon,
        menuText: 'FUNDS',
        isExternal: false,
        openInNewTab: false,
        route: '/'
    },
    {
        menuIcon: DocumentIcon,
        menuText: 'DOCUMENTS',
        isExternal: false,
        openInNewTab: false,
        route: '/documents'
    },
]

export default menuItems



// WEBPACK FOOTER //
// ./src/components/LeftMenu/menuItems.js